import { render, staticRenderFns } from "./AnswersChat.vue?vue&type=template&id=1a35fd28&scoped=true"
import script from "./AnswersChat.vue?vue&type=script&lang=js"
export * from "./AnswersChat.vue?vue&type=script&lang=js"
import style0 from "./AnswersChat.vue?vue&type=style&index=0&id=1a35fd28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a35fd28",
  null
  
)

export default component.exports